import { Spinner } from 'components/common/spinners/Spinner';
import { Spacer } from 'components/layouts/Spacer';
import { UserCard } from 'components/legacy/UserCardContainer';
import { Heading2 } from 'components/typography';
import { useFetchUsersQuery } from 'generated/graphql';
import { UserFeedLayout } from 'views/feeds/userFeed/UserFeed.styles';
import { PageModuleTypeProp } from '../PageModule.types';

export const UserFeed = ({ module }: { module: PageModuleTypeProp<'UserFeedRegular'> }) => {
  const fetchUsers = useFetchUsersQuery({ variables: { first: 6, filter: 'per' } });

  if (fetchUsers.loading) {
    return <Spinner />;
  }

  if (!fetchUsers.data?.users?.edges) {
    return null;
  }

  const { users } = fetchUsers.data;
  return (
    <>
      <Heading2>{module.title}</Heading2>
      <Spacer height={16} />
      <UserFeedLayout>
        {users.edges.map(user => (
          <UserCard user={user.node} key={user.node.id} />
        ))}
      </UserFeedLayout>
    </>
  );
};

export default UserFeed;
